import { useState } from 'react';
import { useMeasure } from 'react-use';

import Flex from 'quarks/Flex';
import Grid from 'quarks/Grid';
import type { FlexProps } from 'quarks/interpolations/flex';

import Pagination from 'molecules/Pagination/Pagination';

import CustomerStoryCard from 'components/CustomerStory/CustomerStoryCard';

import type { ContentfulTemplateCustomerStory } from 'graphqlTypes';
import type { FC } from 'react';

interface CardDeckProps extends FlexProps {
  cards: ContentfulTemplateCustomerStory[];
}

const CardDeck: FC<CardDeckProps> = ({ cards, ...props }) => {
  const [activeIndex, setActive] = useState(0);
  const [ref, { width: cardWidth }] = useMeasure<HTMLDivElement>();

  const length = cards?.length || 0;
  const gap = 30;

  const setActiveDot = (dot: number) => setActive(dot);
  const leftArrowClick = () => activeIndex !== 0 && setActive(activeIndex - 1);
  const rightArrowClick = () => activeIndex !== length - 1 && setActive(activeIndex + 1);

  return (
    <Flex flexDirection="column" gap="40px" width="100%" {...props}>
      {cards && (
        <Flex flexDirection="column" alignItems="center" gap="32px">
          <Flex overflowX="visible" width="100%" paddingX={0}>
            <Grid
              display="flex"
              gap={`${gap}px`}
              transform={`translateX(-${activeIndex * (cardWidth + gap)}px)`}
              transition="transform 0.5s ease"
              minWidth={`calc(100% * ${length} + (${gap}px * ${length && length - 1}))`}
              paddingY={6}
              lg={{ display: 'grid', gridTemplateColumns: `repeat(${length}, 1fr)`, minWidth: '100%' }}
            >
              {cards.map(({ id, slug, company, heading, logoShouldNotFilterColor }, index) => (
                <Flex
                  // eslint-disable-next-line react/no-array-index-key
                  key={`more-customers-${id}-${index}`}
                  ref={ref}
                >
                  <CustomerStoryCard
                    tabIndex={index === activeIndex ? 0 : -1}
                    slug={slug}
                    logo={company?.onLightLogo}
                    name={company?.name}
                    heading={heading}
                    logoShouldNotFilterColor={logoShouldNotFilterColor}
                  />
                </Flex>
              ))}
            </Grid>
          </Flex>
          <Flex justifyContent="center" display="flex" lg={{ display: 'none' }}>
            <Pagination
              activeDot={activeIndex}
              variant="dark"
              dotsCount={length}
              onSetActiveDot={setActiveDot}
              onLeftArrowClick={leftArrowClick}
              onRightArrowClick={rightArrowClick}
            />
          </Flex>
        </Flex>
      )}
    </Flex>
  );
};
export default CardDeck;
